import * as Sentry from "@sentry/react";

// GMA-1412: Sentry is initialized exactly once, in src/index.js — the single
// source of truth for DSN / release / ignoreErrors / beforeSend (scanner-UA +
// AbortError filtering). This module provides only the shared capture /
// breadcrumb / user helpers imported across the app.
//
// Removed here (dead/duplicate, see GMA-1412): a never-called initSentry() that
// duplicated the Sentry.init config, and an orphaned advanced-Sentry helper
// module (showUserFeedbackDialog, 0 imports). Do not re-introduce a 2nd init.

export const captureError = (error, context = {}) => {
  Sentry.captureException(error, {
    tags: context.tags || {},
    extra: context.extra || {},
    level: context.level || "error",
  });
};

export const captureMessage = (message, context = {}) => {
  Sentry.captureMessage(message, {
    level: context.level || "info",
    tags: context.tags || {},
    extra: context.extra || {},
  });
};

export const addBreadcrumb = (message, data = {}) => {
  Sentry.addBreadcrumb({
    message,
    category: data.category || "custom",
    level: data.level || "info",
    data: data,
  });
};

export const setUser = (user) => {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name || user.firstName,
    userType: user.userType,
  });
};
